/**
 * Slash command store — merges commands declared in config with commands the
 * backend enables at webcall time. Config commands win on collisions.
 */
import { createStore } from "./store.js";
export function createSlashCommandStore(configCommands = []) {
    let runtimeCommands = [];
    const build = () => {
        const seen = new Set(configCommands.map((c) => c.command));
        const merged = [...configCommands];
        for (const cmd of runtimeCommands) {
            if (!seen.has(cmd.command))
                merged.push(cmd);
        }
        return { commands: merged };
    };
    const handle = createStore(build);
    return {
        getSnapshot: handle.getSnapshot,
        subscribe: handle.subscribe,
        dispose: handle.dispose,
        setRuntimeCommands(commands) {
            runtimeCommands = commands;
            handle.commit();
        },
        reset() {
            runtimeCommands = [];
            handle.commit();
        },
    };
}
